<template>
  <div>
    
    <div style="margin-top: 50px; display: flex; flex-direction: column; justify-content: center; align-items: center;">
        <div 
            style="margin-top: 50px; display: flex; 
            flex-direction: column; 
            width: 400px; 
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1); 
            padding: 20px;
            justify-content: center; align-items: center;">

                <img alt="Easy Tailor App Logo" :src="getTopLogo" style="max-width: 150px; ">

                <div style="margin-top: 50px; display: flex; flex-direction: column; width: 80%;  justify-content: flex-start; align-items: flex-start;">

                    <div style="text-align: left;">
                        <b>Please submit your registered email address and submit, we will email you a new password.</b>
                    </div>
                    <br><br>
                    <span type="label">Email Address</span>
                    <el-input @focus="$event.target.select()"
                        v-model="user_name">
                    </el-input>

                </div>
                
                <div style="margin-top: 20px; display: flex; flex-direction: row; width: 80%;  justify-content: space-between; align-items: space-between;">
                    <el-button :loading="$store.getters.getLoadingState" @click="forgotPassword" type="primary" size="small">Submit</el-button>
                    <el-link @click="$router.push('/login')">I Remember My Password</el-link>
                        
                </div>

        </div>
    </div>
        
  </div>
</template>

<script>
export default {
    data() {
        return {
            user_name: '',
            processing: false
        }
    },
    computed: {
        getTopLogo() {
            let logo = localStorage.getItem('default_logo')
            if(logo !== null) {
                if(logo.length === 0) {
                    logo = "https://etacdn.b-cdn.net/eta-new-logo.pngg"
                }
            } else {
                logo = "https://etacdn.b-cdn.net/white-blank.png"
            }
            return logo
        },
        isProcessing() {
            return this.processing
        },
        getCurrentHostName() {
            return window.location.hostname
        },
        isHomeDomain() {
            return this.getCurrentHostName.includes('cloud.easytailor') || this.getCurrentHostName.includes('localhost')
        }
    },
    methods: {
        async forgotPassword() {

            this.processing = true

            await this.$store.dispatch('forgotPassword', {user_name: this.user_name})

            setTimeout(() => {
                this.processing = false
                this.user_name = ""
            }, 1000);

        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/Session/ForgotPassword.vue